import type { IconNode } from '../types';

/**
 * @name toast
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNNS41IDNBMy41IDMuNSAwIDAgMCAzIDguOVYxOWEyIDIgMCAwIDAgMiAyaDE0YTIgMiAwIDAgMCAyLTJWOC45QTMuNSAzLjUgMCAwIDAgMTguNSAzWiIgLz4KICA8cGF0aCBkPSJNNy41IDEwYzAtMS44IDEuMi0zIDMuMi0zIDIuNSAwIDIuNCAxLjUgMy44IDIuNXMyLjUgMSAyLjUgM2MwIDIuMi0xLjIgMy4yLTMuNSAzLjItMS4yIDAtMS4yIDEuMi0zIDEuMlM3IDE2IDcgMTQuMmMwLTEuNS44LTEuNS44LTIuNSAwLS43LS4zLTEuMi0uMy0xLjciIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/toast
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const toast: IconNode = [
  [
    'path',
    {
      d: 'M5.5 3A3.5 3.5 0 0 0 3 8.9V19a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8.9A3.5 3.5 0 0 0 18.5 3Z',
      key: 'p232zu',
    },
  ],
  [
    'path',
    {
      d: 'M7.5 10c0-1.8 1.2-3 3.2-3 2.5 0 2.4 1.5 3.8 2.5s2.5 1 2.5 3c0 2.2-1.2 3.2-3.5 3.2-1.2 0-1.2 1.2-3 1.2S7 16 7 14.2c0-1.5.8-1.5.8-2.5 0-.7-.3-1.2-.3-1.7',
      key: 'z4t2fe',
    },
  ],
];

export default toast;
